import { useEffect } from "react";
import { initOneSignal } from "./onesignal";
import ProjectRoutes from "./routes/Routes";
import * as Sentry from "@sentry/react";
import "./App.css";
import "./styles/globalConfirmModal.css";
import ErrorPage from "./components/ErrorPages/ErrorPage";

function App() {
  useEffect(() => {
    initOneSignal();
  }, []);

  function FallbackComponent() {
    return <ErrorPage />;
  }

  return (
    <Sentry.ErrorBoundary fallback={<FallbackComponent />}>
      <ProjectRoutes />
    </Sentry.ErrorBoundary>
  );
}

export default App;
